import PageShell from "@/components/PageShell";
import Resources from "@/components/Resources";

export default function ResourcesPage({ onLead }) {
  return (
    <PageShell backdrop="/homes/sol-office.webp" title="Resources & Guides — My First Home Mortgage Ltd">
      <Resources onLead={onLead} />
    </PageShell>
  );
}
